module.exports = "<ui-view>\n    <ul class=\"list-inline row\">\n        <li class=\"video-card col-xs-12 col-sm-4 text-center\"\n            ui-sref=\".show({videoId: video.id.videoId})\"\n            ng-repeat=\"video in $ctrl.videos track by $index\">\n\n            <img class=\"video-thumbnail\" ng-src=\"{{video.snippet.thumbnails.medium.url}}\"/>\n\n            <h2 class=\"video-title\">\n                {{video.snippet.title}}\n            </h2>\n        </li>\n    </ul>\n</ui-view>"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/apps/youtube/youtube.html
// module id = 563
// module chunks = 0